import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7b33dd5a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7b33dd5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b33dd5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b33dd5a')) {
      api.createRecord('7b33dd5a', component.options)
    } else {
      api.reload('7b33dd5a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7b33dd5a&scoped=true&", function () {
      api.rerender('7b33dd5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/cardholder-change/index.vue"
export default component.exports